import type { ReactElement, ReactNode } from "react";
import { useMemo, useState } from "react";
import { ThreeDotsOverlayContext } from "./ThreeDotsOverlayContext";

export const ThreeDotsOverlayProvider = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  const [isVisible, setIsVisible] = useState(false);

  const contextValue = useMemo(
    () => ({
      isVisible,
      showOverlay: (): void => {
        setIsVisible(true);
      },
      hideOverlay: (): void => {
        setIsVisible(false);
      },
    }),
    [isVisible],
  );

  return (
    <ThreeDotsOverlayContext.Provider value={contextValue}>
      {children}
    </ThreeDotsOverlayContext.Provider>
  );
};
